'use strict';

import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import styles from './assets/indexResponse.module.css';

const print = function (value) { };
class DDS_lanhupage_3 extends Component {
  state = { currentTab: 0, };
  setValue(val) { }
  onToggleTab = (value) => {
    this.setState({ currentTab: value })
  }
  onNextSlide = () => {
    //var i = this.state.currentSlideIndex + 1;
    //this.props.onClickNextcurrentSLide(i)
    document.getElementById('mainwrap').scrollBy({
      top: 20, // 垂直滚动500px
      left: 0, // 水平位置（这里不改变）
      behavior: 'smooth' // 平滑滚动效果
    });
  }
  render() {
    return (
      <div className={`${styles.page} flex-col`}>
        <div className={`${styles['box_22']} flex-row indexResponse_box_22__1wgXJ  indexResponse_box_22__1PAuR`}>
          <div className={`${styles['block_8']} flex-col justify-between indexResponse_block_8__10KkT `}>

            <div className={`${styles['block_2']} flex-col indexResponse_block_2__1yJgF`}>
              <span class="indexResponse_text_3__1uKQD indexResponse_text_3__32nG- ">JiaYingInternationl</span>
              <div className={`${styles['box_4']} flex-col indexResponse_box_4__hROd8`} />
              <div className={`${styles['box_6']} flex-col indexResponse_box_6__2nXyL`} />
              <span className={`${styles['text_4']} indexResponse_text_4__1Urnx`}>我们的业务</span>
              <div className={`${styles['box_5']} flex-col indexResponse_box_5__1Ist-`} />
              <div className={`${styles['box_7']} flex-col indexResponse_box_7__1-9QO`} />

              <img
                className={`${styles['image_4']} indexResponse_image_4__3MqGs`}
                src={
                  require('./assets/img/SketchPng2a8675b81e27764903f1304c221689ced87ea3dbbfa3996be807f85d83d596d3.png')
                }
              />

            </div>
          </div>
          <div className={`${styles['block_9']} flex-col indexResponse_block_9__2Wqql `}>
            <div className={`${styles['box_1']} flex-col indexResponse_box_1__3I4-s indexResponse_box_1__3EMJL`}>
              <div className={`indexrepose_font_title`}>我们的业务</div>
            </div>

            <img
              className={`clickable ${styles['image_2']} indexResponse_image_2__2ee7o`}
              onClick={() => this.onNextSlide()}
              src={
                require('./assets/img/SketchPngd08825a154ca581054fc75372f7edca364d9ed279fa43b889c445ea09526f894.png')
              }
            />
            <img
              className={`clickable ${styles['image_3']} indexResponse_image_3__B0nx6`}

              src={
                require('./assets/img/SketchPng1043bd5c5c67398c345b9723acb5e8d9485cafdf0c89eca728c1f52603b44a47.png')
              }
            />

          </div>
        </div>
        <div className={`${styles['box_20']} indexResponse_box_20__4phJ9 indexResponse_box_20__1VkIY fade-out`}>
          <div className='dv_trake_change flex-row between'>
            <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>马来西亚硕博留学</div>
            <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>西班牙本硕留学</div>
            <div className={this.state.currentTab == 2 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>法国本硕留学</div>
            <div className={this.state.currentTab == 3 ? 'tab selected tablast' : 'tab clickable'} onClick={() => this.onToggleTab(3)}>澳洲留学</div>
          </div>
          {this.state.currentTab == 0 && <div className='dv_img_banner_bg'>
            <div className='dv_bottom_title'>
              <div className='dv_smallsudey_title'>马来西亚硕博留学</div>
              <div className='dv_la_phygraphy'>马来西亚硕博留学项目——重点推荐外方院校</div>
              <div className='dv_button_linkto clickable'>
                <Link to='/Project/Ma'><span>查看详情</span></Link>
                <img
                  className='dv_img_arriw_f'
                  src={
                    require('./assets/img/SketchPngd2349a5f07b00c012d52de23c774f9643242205efe55c5073ef96cda5a197319.png')
                  }
                />
              </div>
            </div>
            <img
              className='dv_img_school_wrap'
              src={
                require('./assets/img/3.jpg')
              }
            />
          </div>
          }
          {this.state.currentTab == 1 && <div className='dv_img_banner_bg'>
            <div className='dv_bottom_title'>
              <div className='dv_smallsudey_title'>西班牙本硕留学</div>
              <div className='dv_la_phygraphy'>西班牙硕博留学项目——重点推荐外方院校</div>
              <div className='dv_button_linkto clickable'>
                <Link to='/Project/Es'><span>查看详情</span></Link>
                <img
                  className='dv_img_arriw_f'
                  src={
                    require('./assets/img/SketchPngd2349a5f07b00c012d52de23c774f9643242205efe55c5073ef96cda5a197319.png')
                  }
                />
              </div>
            </div>
            <img
              className='dv_img_school_wrap'
              src={
                require('./assets/img/2.jpg')
              }
            />
          </div>
          }

          {this.state.currentTab == 2 && <div className='dv_img_banner_bg'>
            <div className='dv_bottom_title'>
              <div className='dv_smallsudey_title'>法国本硕留学</div>
              <div className='dv_la_phygraphy'>法国本硕留学项目——重点推荐外方院校</div>
              <div className='dv_button_linkto clickable'>
                <Link to='/Project/Fr'><span>查看详情</span></Link>
                <img
                  className='dv_img_arriw_f'
                  src={
                    require('./assets/img/SketchPngd2349a5f07b00c012d52de23c774f9643242205efe55c5073ef96cda5a197319.png')
                  }
                />
              </div>
            </div>
            <img
              className='dv_img_school_wrap'
              src={
                require('./assets/img/4.jpg')
              }
            />
          </div>
          }
          {this.state.currentTab == 3 && <div className='dv_img_banner_bg'>
            <div className='dv_bottom_title'>
              <div className='dv_smallsudey_title'>澳洲留学</div>
              <div className='dv_la_phygraphy'>澳⼤利亚跨国教育 (TNE)
                ⼤学预科及就业预备项⽬</div>
              <div className='dv_button_linkto clickable'>
                <Link to='/Project/Au'><span>查看详情</span></Link>
                <img
                  className='dv_img_arriw_f'
                  src={
                    require('./assets/img/SketchPngd2349a5f07b00c012d52de23c774f9643242205efe55c5073ef96cda5a197319.png')
                  }
                />
              </div>
            </div>
            <img
              className='dv_img_school_wrap'
              src={
                require('./assets/img/5.jpg')
              }
            />
          </div>
          }


        </div>
      </div>
    );
  }
}
export default DDS_lanhupage_3;
